export * from './card-ccs-component-config.interface';
